import * as React from 'react';
import { Link, withRouter } from 'react-router';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';
import { IAuthContext, ILanguage } from 'models/common';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import renderIcon from 'helpers/renderIcon';
import Slider from 'react-slick';
import { ContactUsForm } from './ContactUsForm';
const classNames = require('classnames');

interface IProps {
	context: IAuthContext;
	t?: (key: string) => string;
	customTextKey?: string;
	customUrl?: string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class CreateShopRegisterComponent extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);
	}

	private handleOnRegisterClick(e, signinRedirectJoin) {
		e.preventDefault();
		signinRedirectJoin();
	}

	public render() {
		const { t } = this.props;
		const { customTextKey, customUrl } = this.props;
		const { signinRedirectJoin, isAuthenticated } = this.props.context;

		return (
			<>
				{customUrl ? (
					<a href={customUrl}>
						<button className="btnPrimary bsPortalBtn bsPortalBtnLarge salon-create-header-section__button">
							{t(customTextKey || 'CreateShopPresentation_OpenSalon_Short')}
						</button>
					</a>
				) : isAuthenticated() ? (
					<Link to="/salon/create">
						<button className="btnPrimary bsPortalBtn bsPortalBtnLarge salon-create-header-section__button">
							{t(customTextKey || 'CreateShopPresentation_OpenSalon_Short')}
						</button>
					</Link>
				) : (
					<a href="#" onClick={(e) => this.handleOnRegisterClick(e, signinRedirectJoin)}>
						<button className="btnPrimary bsPortalBtn bsPortalBtnLarge salon-create-header-section__button">
							{t(customTextKey || 'Navigation_Main_UserMenu_Register')}
						</button>
					</a>
				)}
			</>
		);
	}
}

const CreateShopRegister = withAuthContext(CreateShopRegisterComponent);

const mockup_desktop = require('containers/Html/images/ShopPresentation/mockup_desktop.png');
const banner_image = require('containers/Html/images/ShopPresentation/banner.png');

import Check from '-!svg-react-loader!containers/Html/icons/ShopPresentation/Check.svg';
import Close from '-!svg-react-loader!containers/Html/icons/ShopPresentation/Close.svg';
import Hamburger from '-!svg-react-loader!containers/Html/icons/ShopPresentation/Hamburger.svg';
import { LanguageDropdown } from 'components';
import { IStore } from 'redux/IStore';
import { Dispatch, connect } from 'react-redux';
import { changeLanguage } from 'redux/modules/user/userlanguage';
import { MenuItemType } from 'models/enums/menuitemtype';
import { getPublishedMenuItems } from 'redux/modules/menus/mainmenu';

interface IFeatureMockup {
	title: string;
	description: string;
	image: any;
	label: string;
}
const getFeatureMockups: (t) => Array<IFeatureMockup> = (t) =>
	new Array(6).fill(0).map((_, i) => {
		const prefix = `CreateShopPresentation_FeatureMockups_${i}_`;
		return {
			label: t(`${prefix}Label`),
			title: t(`${prefix}Title`),
			description: t(`${prefix}Description`),
			image: require(`containers/Html/images/ShopPresentation/feature_mockup_${i}.png`),
		};
	});

interface IPlan {
	title: string;
	subtitle: string;
	price: string;
	priceDescription: string;
	featuresTitle: string;
	features: string[][];
	mostPopular: boolean;
}
const planNames = ['Basic', 'Premium', 'Premium2'];
const getPlans: (t) => Array<IPlan> = (t) =>
	[5, [1, 2, 1, 1, 1], [1, 2, 1]].map((number_of_features, i) => {
		const prefix = `CreateShopPresentation_Pricing_${planNames[i]}`;
		return {
			title: t(`${prefix}_Title`),
			subtitle: t(`${prefix}_Subtitle`),
			price: t(`${prefix}_Price`),
			priceDescription: t(`${prefix}_PriceDescription`),
			featuresTitle: t(`${prefix}_FeaturesTitle`),
			features:
				number_of_features instanceof Array
					? number_of_features.map((num, i) =>
							num == 1
								? [t(`${prefix}_Feature_${i}`)]
								: new Array(num).fill(0).map((_, j) => (i == 0 ? '' : ' ') + t(`${prefix}_Feature_${i}_${j}`)),
					  )
					: new Array(number_of_features).fill(0).map((_, i) => [t(`${prefix}_Feature_${i}`)]),
			mostPopular: i == 1,
		};
	});
const fc_prefix = 'CreateShopPresentation_FeaturesComparison_Aditional';
const featuresComparison = [
	...new Array(11).fill([1, 1, 1]),
	[`${fc_prefix}_8`, [`${fc_prefix}_9`, `${fc_prefix}_0`], [`${fc_prefix}_10`, `${fc_prefix}_1`]],
	...new Array(6).fill([0, 1, 1]),
	...new Array(1).fill([0, 0, 1]),
	[`${fc_prefix}_2`, `${fc_prefix}_3`, `${fc_prefix}_4`],
	[`${fc_prefix}_5`, `${fc_prefix}_6`, `${fc_prefix}_7`],
];
const getFeatureDescription = (t, i) => {
	if (i == 11) {
		return t('CreateShopPresentation_FeaturesComparison_Aditional_11');
	}
};

const CreateShopPresentationW = withRouter(
	translate(c.DEFAULT_TRANSLATION_NAMESPACE)(
		({ t, location, languageDomainValues, userLanguage, changeLanguage, getPublishedMenuItems, context }) => {
			const [faqDropdowns, setFaqDropdowns] = React.useState([true]);
			const [mobileNavMenu, setMobileNavMenu] = React.useState(false);
			const [mobileLanguagePicker, setMobileLanguagePicker] = React.useState(false);
			// /shop and /features are on this component, /features has some elements hidden
			const isFeaturesComparisonPage = location?.pathname?.includes('features');

			const toggleFaqDropdown = (i) => {
				const newDropdowns = new Array(faqDropdowns?.length);
				newDropdowns[i] = !faqDropdowns?.[i];
				setFaqDropdowns(newDropdowns);
			};

			React.useEffect(() => {
				const listener = () => {
					const newPadding =
						(window.innerWidth - document.querySelector('.container').getBoundingClientRect().width) / 2;

					const paddingContainer = document.querySelector('.shop-present__reviews .slick-track') as HTMLDivElement;
					if (paddingContainer) {
						paddingContainer.style.paddingLeft = `${newPadding}px`;
					}
				};

				listener();
				window.addEventListener('resize', listener);
				return () => window.removeEventListener('resize', listener);
			}, []);

			const blob1 = React.useRef<any>();
			const blob2 = React.useRef<any>();
			const wrapperRef = React.useRef<HTMLDivElement>();

			const linearFncThroughtTwoPoints = (a, b) => {
				const k = (b[1] - a[1]) / (b[0] - a[0]);
				const n = a[1] - k * a[0];
				return (x) => k * x + n;
			};

			React.useEffect(() => {
				const blob1CenterDesktop = [547 / 2 + 24, 547 / 2 - 115]; // [297.5,158.5]
				const blob1CenterMobile = [167 / 2 - 34, 167 / 2 - 7]; // [49.5,76.5]
				const blob2CenterDesktop = [1920 - (1096 / 2 + 1030), 1080 - (1096 / 2 + 1030)]; // [342,-498]
				const blob2CenterMobile = [360 - (336 / 2 + 208), 640 - (336 / 2 + 364)]; // [-16,108]

				const blob1TopInterpolator = linearFncThroughtTwoPoints(
					[1920, blob1CenterDesktop[1]],
					[360, blob1CenterMobile[1]],
				);
				const blob1LeftInterpolator = linearFncThroughtTwoPoints(
					[1920, blob1CenterDesktop[0]],
					[360, blob1CenterMobile[0]],
				);
				const blob2BottomInterpolator = linearFncThroughtTwoPoints(
					[1920, blob2CenterDesktop[1]],
					[360, blob2CenterMobile[1]],
				);
				const blob2RightInterpolator = linearFncThroughtTwoPoints(
					[1920, blob2CenterDesktop[0]],
					[360, blob2CenterMobile[0]],
				);

				const sizeInterpolator1 = linearFncThroughtTwoPoints([1920, 1911], [360, 588]);
				const sizeInterpolator2 = linearFncThroughtTwoPoints([1920, 2500], [360, 766]);

				let blob1Top;
				let blob1Left;
				let blob2Right;
				let blob2Bottom;
				let size1;
				let size2;
				const listener = () => {
					if (blob1.current && blob2.current) {
						size1 = sizeInterpolator1(window.innerWidth);
						size2 = sizeInterpolator2(window.innerWidth);

						blob1Top = blob1TopInterpolator(window.innerWidth) - size1 / 2;
						blob1Left = blob1LeftInterpolator(window.innerWidth) - size1 / 2;
						blob2Right = blob2RightInterpolator(window.innerWidth) - size2 / 2;
						blob2Bottom = blob2BottomInterpolator(window.innerWidth) - size2 / 2;

						blob1.current.style.top = `${blob1Top}px`;
						blob1.current.style.left = `${blob1Left}px`;
						blob2.current.style.bottom = `${blob2Bottom}px`;
						blob2.current.style.right = `${blob2Right}px`;

						blob1.current.style.width = `${size1}px`;
						blob1.current.style.height = `${size1}px`;
						blob2.current.style.width = `${size2}px`;
						blob2.current.style.height = `${size2}px`;
					}
				};

				listener();

				//window.addEventListener('scroll', listener, { passive: true });
				window.addEventListener('resize', listener, { passive: true });
				return () => {
					//window.removeEventListener('scroll', listener);
					window.removeEventListener('resize', listener);
				};
			}, []);

			// Anchors
			const featuremockupsRef = React.useRef();
			const reviewsRef = React.useRef();
			const faqRef = React.useRef();
			const contactRef = React.useRef();

			const plansDOM = getPlans(t).map((plan, i) => (
				<div className="col-lg-4" key={`plan-${i}`}>
					<div
						className={classNames('shop-present__pricing__cards__card', {
							'shop-present__pricing__cards__card--most-popular': plan.mostPopular,
						})}
					>
						<div className="shop-present__pricing__cards__card__top">
							<h3 className="shop-present__pricing__cards__card__top__title">
								{plan.title}
								{plan.mostPopular && (
									<span className="shop-present__pricing__cards__card__top__title__tag">
										{t('CreateShopPresentation_Pricing_MostPopular')}
									</span>
								)}
							</h3>
							<p className="shop-present__pricing__cards__card__top__subtitle">{plan.subtitle}</p>
							<h2 className="shop-present__pricing__cards__card__top__price">{plan.price}</h2>
							<p className="shop-present__pricing__cards__card__top__priceDescription">{plan.priceDescription}</p>
							<h4 className="shop-present__pricing__cards__card__top__featuresTitle">{plan.featuresTitle}</h4>
							<div className="shop-present__pricing__cards__card__top__features">
								{plan.features.map((feature, i) => (
									<div className="shop-present__pricing__cards__card__top__features__feature" key={`topFeature-${i}`}>
										<span className="shop-present__pricing__cards__card__top__features__feature__icon-wrapper">
											{renderIcon('check')}
										</span>
										<p className="shop-present__pricing__cards__card__top__features__feature__text-multipart">
											{feature.map((ft, i) => (
												<span key={`featureText-${i}`}>{ft}</span>
											))}
										</p>
									</div>
								))}
							</div>
						</div>
						<div className="shop-present__pricing__cards__card__select-plan-button">
							{i == 2 ? (
								<CreateShopRegister
									customUrl="mailto:info@glossiq.com"
									customTextKey="CreateShopPresentation_Pricing_ContactUs"
								/>
							) : (
								<CreateShopRegister customTextKey="CreateShopPresentation_Pricing_SelectPlan" />
							)}
						</div>
					</div>
				</div>
			));

			const translatedFeatureMockups = getFeatureMockups(t);
			const featureMockupDOM = translatedFeatureMockups.map((feature, i) => (
				<div className="shop-present__feature-mockups__feature" key={`feature-${i}`}>
					<div className="container">
						<div className="row align-items-center flex-column flex-md-row">
							<div className="col-12 col-md-4">
								<h2 className="shop-present__feature-mockups__feature__title">{feature.title}</h2>
								<p className="shop-present__feature-mockups__feature__description">{feature.description}</p>
							</div>
							<div className="col-12 col-md-8">
								<img
									className="shop-present__feature-mockups__feature__image"
									src={feature.image}
									alt="feature mockup image"
								/>
							</div>
						</div>
					</div>
				</div>
			));

			const getReviews = (mobile) =>
				new Array(4).fill(0).map((_, i) => {
					const inner = (
						<div className="shop-present__reviews__reviews-container__review-container__review">
							{renderIcon(
								'quote',
								undefined,
								undefined,
								'shop-present__reviews__reviews-container__review-container__review__icon',
							)}
							<div className="shop-present__reviews__reviews-container__review-container__review__body">
								{t(`CreateShopPresentation_Reviews_Review_${i}_Body`)}
							</div>
							<div className="shop-present__reviews__reviews-container__review-container__review__person">
								<img
									src={require(`containers/Html/images/ShopPresentation/person_${i}.png`)}
									className="shop-present__reviews__reviews-container__review-container__review__person__image"
									alt={`image of ${t(`CreateShopPresentation_Reviews_Review_${i}_Name`)}`}
								/>
								<div className="shop-present__reviews__reviews-container__review-container__review__person__name-container">
									<div className="shop-present__reviews__reviews-container__review-container__review__person__name-container__name">
										{t(`CreateShopPresentation_Reviews_Review_${i}_Name`)}
									</div>
									<div className="shop-present__reviews__reviews-container__review-container__review__person__name-container__description">
										{t(`CreateShopPresentation_Reviews_Review_${i}_Description`)}
									</div>
								</div>
							</div>
						</div>
					);

					if (mobile) {
						return (
							<div
								className="shop-present__reviews__reviews-container__review-container shop-present__reviews__reviews-container__review-container--mobile container"
								key={`mobile-review-${i}`}
							>
								<div className="row">
									<div className="col-12">{inner}</div>
								</div>
							</div>
						);
					}

					return (
						<div className="shop-present__reviews__reviews-container__review-container container" key={`review-${i}`}>
							{inner}
						</div>
					);
				});

			const scrollToRef = (e, ref) => {
				if (!isFeaturesComparisonPage) {
					e.preventDefault();
					ref?.current?.scrollIntoView({ block: 'start', behavior: 'smooth' });
				}
			};

			const getMobileLanguagePicker = () => {
				const languageOptions: ILanguage[] = [];

				let selectedLanguageName = '';
				if (userLanguage?.languageKey && languageDomainValues) {
					selectedLanguageName = languageDomainValues.find((v) => v.key === userLanguage?.languageKey)?.value || '';
				}

				let i: number;
				if (languageDomainValues?.length > 0) {
					for (i = 0; i < 4; i++) {
						//remove when CH and RU languages are supported
						if (languageDomainValues[i] && languageDomainValues[i].key && languageDomainValues[i].culture) {
							languageOptions.push(languageDomainValues[i]);
						}
					}
				}

				return (
					<div className="shop-present__navMenu__nav__mobileLanguages">
						<div
							className="shop-present__navMenu__nav__mobileLanguages__title"
							onClick={() => {
								setMobileLanguagePicker(false);
							}}
						>
							{renderIcon('landing_page_down', 16, 16, 'shop-present__navMenu__nav__mobileLanguages__back')}
							{t('User_UserPreferences_Dropdown_SelectLanguage')}
						</div>
						<div className="shop-present__navMenu__nav__mobileLanguages__wrapper">
							{languageOptions.map((opt) => {
								return (
									<figure
										key={opt.key}
										onClick={() => {
											changeLanguage(opt.key, context.isAuthenticated());
											getPublishedMenuItems(MenuItemType.Portal);
											setMobileLanguagePicker(false);
										}}
										className={selectedLanguageName === opt.value ? 'active' : ''}
									>
										<span>{opt.value}</span>
									</figure>
								);
							})}
						</div>
					</div>
				);
			};

			return (
				<div className="shop-present" ref={wrapperRef}>
					<div className="shop-present__blob1" ref={blob1}></div>
					<div className="shop-present__blob2" ref={blob2}></div>

					<div className="shop-present__zIndexContainer">
						{mobileNavMenu && (
							<div className="shop-present__navMenu">
								<div className="container">
									<div className="row">
										<div className="col-12">
											<div className="shop-present__navMenu__header">
												<Close
													className="shop-present__navMenu__header__closeButton"
													onClick={() => setMobileNavMenu(false)}
												/>
											</div>
										</div>
									</div>
								</div>
								<div className="container">
									<div className="row">
										<div className="col-12">
											{mobileLanguagePicker ? (
												<div className="shop-present__navMenu__nav">{getMobileLanguagePicker()}</div>
											) : (
												<div className="shop-present__navMenu__nav">
													<Link
														className="shop-present__navMenu__nav__anchorLink"
														onClick={(e) => {
															setMobileNavMenu(false);
															scrollToRef(e, featuremockupsRef);
														}}
														to={'/forBusiness#featuremockups'}
													>
														{t('CreateShopPresentation_Header_Nav_0')}
													</Link>
													<Link
														className="shop-present__navMenu__nav__anchorLink"
														onClick={(e) => {
															setMobileNavMenu(false);
															scrollToRef(e, reviewsRef);
														}}
														to={'/forBusiness#reviews'}
													>
														{t('CreateShopPresentation_Header_Nav_1')}
													</Link>
													<Link
														className="shop-present__navMenu__nav__anchorLink"
														onClick={(e) => {
															setMobileNavMenu(false);
															scrollToRef(e, faqRef);
														}}
														to={'/forBusiness#faq'}
													>
														{t('CreateShopPresentation_Header_Nav_2')}
													</Link>
													<Link
														className="shop-present__navMenu__nav__anchorLink"
														onClick={(e) => {
															setMobileNavMenu(false);
															scrollToRef(e, contactRef);
														}}
														to={'/forBusiness#contact'}
													>
														{t('CreateShopPresentation_Header_Nav_3')}
													</Link>
													<Link
														className="nav__buttonLink"
														onClick={() => setMobileNavMenu(false)}
														to={'/forBusiness/create'}
													>
														{t('CreateShopPresentation_Header_Nav_4')}
													</Link>

													<div className="shop-present__navMenu__nav__mobileLanguagesButtonBorder"></div>

													<div
														className="shop-present__navMenu__nav__mobileLanguagesButton"
														onClick={() => {
															setMobileLanguagePicker(true);
														}}
													>
														{t('BSPortal_Common_Filter_Language')}
													</div>
												</div>
											)}
										</div>
									</div>
								</div>
							</div>
						)}
						<header className="shop-present__actualHeader">
							<div className="container">
								<div className="row">
									<div className="col-12">
										<div className="shop-present__actualHeader__inner">
											<div className="shop-present__actualHeader__inner__leftSection">
												<Link to={'/'}>
													<img
														className="white"
														src={require('containers/Html/images/logo/glossiq-white.svg')}
														alt={t('App_Name')}
													/>
												</Link>
												<div className="shop-present__actualHeader__inner__nav__left">
													<Link
														className="shop-present__actualHeader__inner__nav__anchorLink"
														onClick={(e) => {
															scrollToRef(e, featuremockupsRef);
														}}
														to={'/forBusiness#featuremockups'}
													>
														{t('CreateShopPresentation_Header_Nav_0')}
													</Link>
													<Link
														className="shop-present__actualHeader__inner__nav__anchorLink"
														onClick={(e) => {
															scrollToRef(e, reviewsRef);
														}}
														to={'/forBusiness#reviews'}
													>
														{t('CreateShopPresentation_Header_Nav_1')}
													</Link>
													<Link
														className="shop-present__actualHeader__inner__nav__anchorLink"
														onClick={(e) => {
															scrollToRef(e, faqRef);
														}}
														to={'/forBusiness#faq'}
													>
														{t('CreateShopPresentation_Header_Nav_2')}
													</Link>
													<Link
														className="shop-present__actualHeader__inner__nav__anchorLink"
														onClick={(e) => {
															scrollToRef(e, contactRef);
														}}
														to={'/forBusiness#contact'}
													>
														{t('CreateShopPresentation_Header_Nav_3')}
													</Link>
												</div>
											</div>

											<div className="shop-present__actualHeader__inner__nav__right">
												<LanguageDropdown
													className={'d-none d-lg-inline-block'}
													onLanguageChange={(val) => {
														const languageKey = parseInt(val, 10);
														changeLanguage(languageKey, context.isAuthenticated());
														getPublishedMenuItems(MenuItemType.Portal);
													}}
													languageDomainValues={languageDomainValues}
													selectedLanguage={userLanguage?.languageKey}
												/>
												<Link className="nav__buttonLink" to={'/salon/create'}>
													{t('CreateShopPresentation_Header_Nav_4')}
												</Link>
											</div>

											<Hamburger
												className="shop-present__actualHeader__inner__nav__mobileButton"
												onClick={() => setMobileNavMenu(true)}
											/>
										</div>
									</div>
								</div>
							</div>
						</header>
						{!isFeaturesComparisonPage && (
							<>
								{/* HEADER */}
								<div className="shop-present__header">
									<div className="container">
										<div className="row justify-content-center">
											<div className="col-10">
												<h1
													className="shop-present__header__title"
													dangerouslySetInnerHTML={{ __html: t('CreateShopPresentation_Header_Title') }}
												/>
											</div>
										</div>
										<div className="row justify-content-center">
											<div className="col-7 col-lg-4 col-xlg-2">
												<CreateShopRegister isButton={true} />
											</div>
										</div>
									</div>
									<div className="container">
										<div className="row">
											<div className="col-12">
												<div className="shop-present__header__mockup-images">
													<div className="shop-present__header__mockup-images__inner">
														<img
															className="shop-present__header__mockup-images__inner__mockup_desktop"
															src={mockup_desktop}
															alt="glossiq mockup"
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="shop-present__header__body-container">
										<div className="container">
											<div className="shop-present__header__body">
												<div className="row justify-content-center">
													<div className="col-12 col-md-8">
														<p className="shop-present__header__body__text">
															{t('CreateShopPresentation_Header_Body')}
														</p>
													</div>
												</div>
												<div className="row">
													<div className="col-12 col-md-9 offset-md-2">
														<div className="shop-present__header__body__benefits">
															{[0, 0, 0].map((_, i) => (
																<div className="shop-present__header__body__benefits__benefit" key={`benefit-${i}`}>
																	<h2>{t(`CreateShopPresentation_Header_Benefits_${i}_Title`)}</h2>
																	<p>{t(`CreateShopPresentation_Header_Benefits_${i}_Description`)}</p>
																</div>
															))}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								{/* HEADER */}
								{/* PROMO 0 */}
								<div className="shop-present__promo-0">
									<div className="container">
										<div className="row align-items-baseline flex-column flex-md-row">
											<div className="col-12 col-md-6">
												<div className="row justify-content-center">
													<div className="col-12 col-xlg-10 d-flex align-items-center">
														<h1 className="shop-present__promo-0__title">
															<b>{t('CreateShopPresentation_Promo_0_Title_0')} </b>
															<i>{t('CreateShopPresentation_Promo_0_Title_1')} </i>
															{t('CreateShopPresentation_Promo_0_Title_2')}
															<i> {t('CreateShopPresentation_Promo_0_Title_3')}</i>
														</h1>
													</div>
												</div>
											</div>
											<div className="col-12 col-md-6 d-flex align-items-center">
												<p className="shop-present__promo-0__description">
													{t('CreateShopPresentation_Promo_0_Description')}
												</p>
											</div>
										</div>
									</div>
								</div>
								{/* PROMO 0 */}
								{/* FEATURE MOCKUPS*/}
								<div className="shop-present__feature-mockups" ref={featuremockupsRef}>
									<Slider
										{...{
											dots: true,
											infinite: true,
											speed: 500,
											slidesToShow: 1,
											slidesToScroll: 1,
											arrows: false,
											autoplay: true,
											autoplaySpeed: 8000,
											dotsClass: 'slick-dots container shop-present__feature-mockups__dots',
											beforeChange: (_old_i, new_i) => {
												const i = new_i == 0 ? 0 : new_i - 1;
												const container = document.querySelector('.shop-present__feature-mockups__dots');
												const target = container.childNodes[i] as HTMLLIElement;
												container.scrollBy({
													left: target.getBoundingClientRect().left - container.getBoundingClientRect().left,
													behavior: 'smooth',
												});
											},
											customPaging: (i) => <button>{translatedFeatureMockups[i]?.label}</button>,
										}}
									>
										{featureMockupDOM}
									</Slider>
								</div>
								{/* FEATURE MOCKUPS*/}
								{/* PROMO 1 */}
								<div className="shop-present__promo-1">
									<div className="container">
										<div className="row">
											<div className="col-12">
												<h2 className="shop-present__promo-1__big-title--mobile">
													{t('CreateShopPresentation_Promo_1_BigTitle_0')}
													<b> {t('CreateShopPresentation_Promo_1_BigTitle_1')} </b>
													{t('CreateShopPresentation_Promo_1_BigTitle_2')}{' '}
													<u>{t('CreateShopPresentation_Promo_1_BigTitle_3')}</u>{' '}
													{t('CreateShopPresentation_Promo_1_BigTitle_4')}
													<i> {t('CreateShopPresentation_Promo_1_BigTitle_5')}</i>
												</h2>
											</div>
										</div>
										<div className="row">
											<div className="col-12 col-xl-7">
												<div className="row">
													<div className="col-12 col-sm-6 col-md-5 col-xl-6 col-xlg-5">
														<h3 className="shop-present__promo-1__title shop-present__promo-1__title--first-title">
															{t('CreateShopPresentation_Promo_1_Title_0')}
														</h3>
														<p className="shop-present__promo-1__description">
															{t('CreateShopPresentation_Promo_1_Description_0_0')}{' '}
															<span className="shop-present__promo-1__description--highlight">
																{t('CreateShopPresentation_Promo_1_Description_0_1')}
															</span>{' '}
															{t('CreateShopPresentation_Promo_1_Description_0_2')}
														</p>
													</div>
													<div className="col-12 col-sm-6 col-md-5 offset-md-2 col-xl-6 offset-xl-0 col-xlg-5 offset-xlg-2 shop-present__promo-1__col-2">
														<h3 className="shop-present__promo-1__title shop-present__promo-1__title--first-title">
															{t('CreateShopPresentation_Promo_1_Title_1')}
														</h3>
														<p className="shop-present__promo-1__description">
															{t('CreateShopPresentation_Promo_1_Description_1_0')}{' '}
															<span className="shop-present__promo-1__description--highlight">
																{t('CreateShopPresentation_Promo_1_Description_1_1')}
															</span>{' '}
															{t('CreateShopPresentation_Promo_1_Description_1_2')}
														</p>
													</div>
												</div>
												<div className="row shop-present__promo-1__row-2">
													<div className="col-12 col-sm-6 col-md-5 col-xl-6 col-xlg-5">
														<h3 className="shop-present__promo-1__title">
															{t('CreateShopPresentation_Promo_1_Title_2')}
														</h3>
														<p className="shop-present__promo-1__description">
															{t('CreateShopPresentation_Promo_1_Description_2_0')}{' '}
															<span className="shop-present__promo-1__description--highlight">
																{t('CreateShopPresentation_Promo_1_Description_2_1')}
															</span>{' '}
															{t('CreateShopPresentation_Promo_1_Description_2_2')}
														</p>
													</div>
													<div className="col-12 col-sm-6 col-md-5 offset-md-2 col-xl-6 offset-xl-0 col-xlg-5 offset-xlg-2 shop-present__promo-1__col-2">
														<h3 className="shop-present__promo-1__title">
															{t('CreateShopPresentation_Promo_1_Title_3')}
														</h3>
														<p className="shop-present__promo-1__description">
															{t('CreateShopPresentation_Promo_1_Description_3_0')}{' '}
															<span className="shop-present__promo-1__description--highlight">
																{t('CreateShopPresentation_Promo_1_Description_3_1')}
															</span>{' '}
															{t('CreateShopPresentation_Promo_1_Description_3_2')}
														</p>
													</div>
												</div>
											</div>
											<div className="col-4 offset-1">
												<h2 className="shop-present__promo-1__big-title">
													{t('CreateShopPresentation_Promo_1_BigTitle_0')}
													<b> {t('CreateShopPresentation_Promo_1_BigTitle_1')} </b>
													{t('CreateShopPresentation_Promo_1_BigTitle_2')}{' '}
													<u>{t('CreateShopPresentation_Promo_1_BigTitle_3')}</u>{' '}
													{t('CreateShopPresentation_Promo_1_BigTitle_4')}
													<i> {t('CreateShopPresentation_Promo_1_BigTitle_5')}</i>
												</h2>
											</div>
										</div>
									</div>
								</div>
								{/* PROMO 1 */}
								{/* REVIEWS */}
								<div className="shop-present__reviews" ref={reviewsRef}>
									<div className="container">
										<div className="row">
											<div className="col-12">
												<h2 className="shop-present__reviews__title">{t('CreateShopPresentation_Reviews_Title')}</h2>
											</div>
										</div>
									</div>
									<div className="shop-present__reviews__reviews-container">
										<Slider
											{...{
												dots: true,
												infinite: false,
												speed: 500,
												slidesToShow: 3,
												slidesToScroll: 1,
												showArrows: false,
												responsive: [
													{
														breakpoint: 1700,
														settings: {
															slidesToShow: 2,
														},
													},
													{
														breakpoint: 1000,
														settings: {
															slidesToShow: 1,
														},
													},
												],
											}}
										>
											{getReviews(true)}
										</Slider>
									</div>
								</div>
								{/* REVIEWS */}
							</>
						)}
						{/* PRICING */}
						<div
							className={classNames('shop-present__pricing', {
								'shop-present__pricing--featuresComparison': isFeaturesComparisonPage,
							})}
						>
							<div className="container">
								<div className="row d-flex justify-content-center">
									<div className="col-8">
										<h1 className="title-1 shop-present__pricing__title">
											{t('CreateShopPresentation_Pricing_Title')}
										</h1>
										<p className="shop-present__pricing__subtitle">{t('CreateShopPresentation_Pricing_Subtitle')}</p>
									</div>
								</div>
								{/* TODO Billed annualy/monthly */}
								<Slider
									{...{
										dots: true,
										infinite: false,
										speed: 500,
										slidesToShow: 1,
										slidesToScroll: 1,
										showArrows: false,
									}}
									className="row shop-present__pricing__cards align-items-stretch shop-present--mobile"
								>
									{plansDOM}
								</Slider>
								<div className="row shop-present__pricing__cards align-items-stretch shop-present--desktop">
									{plansDOM}
								</div>
								{!isFeaturesComparisonPage && (
									<div className="row">
										<div className="col-12 d-flex justify-content-center">
											<Link to={'/features'} className="shop-present__pricing__compare-plans-button">
												{t('CreateShopPresentation_ComparePlansButton')}
											</Link>
										</div>
									</div>
								)}
							</div>
						</div>
						{/* PRICING */}
						{/* FEATURES COMPARISON */}
						{isFeaturesComparisonPage && (
							<div className="shop-present__features-comparison">
								<div className="container">
									<div className="row">
										<div className="col-12">
											<h2 className="shop-present__features-comparison__title">
												{t('CreateShopPresentation_FeaturesComparison_Title')}
											</h2>
											<table className="shop-present__features-comparison__table" cellSpacing="0" cellPadding="0">
												<thead className="shop-present__features-comparison__table__header">
													<tr className="shop-present__features-comparison__table__header__padding">
														<td colSpan={3}>
															<div className="shop-present__features-comparison__table__header__padding__inner"></div>
														</td>
													</tr>
													<tr className="shop-present__features-comparison__table__header__header-row">
														<td className="shop-present__features-comparison__table__header__header-row__header-td--first"></td>
														<td className="shop-present__features-comparison__table__header__header-row__header-td">
															<div className="shop-present__features-comparison__table__header__header-row__header-td__inner">
																{t(`CreateShopPresentation_Pricing_Basic_Title`)}
															</div>
														</td>
														<td className="shop-present__features-comparison__table__header__header-row__header-td">
															<div className="shop-present__features-comparison__table__header__header-row__header-td__inner">
																{t(`CreateShopPresentation_Pricing_Premium_Title`)}
															</div>
														</td>
														<td className="shop-present__features-comparison__table__header__header-row__header-td">
															<div className="shop-present__features-comparison__table__header__header-row__header-td__inner">
																{t(`CreateShopPresentation_Pricing_Premium2_Title`)}
															</div>
														</td>
													</tr>
												</thead>
												<tbody>
													{featuresComparison.map((feat, i) => {
														const desc = getFeatureDescription(t, i);

														return (
															<React.Fragment key={`feature${i}`}>
																<tr className="shop-present__features-comparison__table__row shop-present__features-comparison__table__row--mobile">
																	<td
																		colSpan={3}
																		className="shop-present__features-comparison__table__row__first-td shop-present__features-comparison__table__row__first-td--mobile"
																	>
																		<h3 className="shop-present__features-comparison__table__row__first-td__title">
																			{t(`CreateShopPresentation_FeaturesComparison_Name_${i}`)}
																		</h3>
																		{desc && (
																			<p className="shop-present__features-comparison__table__row__first-td__desc">
																				{desc}
																			</p>
																		)}
																	</td>
																</tr>
																<tr
																	key={'feat' + i}
																	className={classNames('shop-present__features-comparison__table__row', {
																		'shop-present__features-comparison__table__row--odd': i % 2 == 1,
																	})}
																>
																	<td className="shop-present__features-comparison__table__row__first-td">
																		<h3 className="shop-present__features-comparison__table__row__first-td__title">
																			{t(`CreateShopPresentation_FeaturesComparison_Name_${i}`)}
																		</h3>
																		{desc && (
																			<p className="shop-present__features-comparison__table__row__first-td__desc">
																				{desc}
																			</p>
																		)}
																	</td>
																	{feat.map((num, i) => (
																		<td
																			className={classNames('shop-present__features-comparison__table__row__td', {
																				'shop-present__features-comparison__table__row__td--accent': i == 1,
																			})}
																			key={`feature-comparison-${i}`}
																		>
																			<div
																				className="shop-present__features-comparison__table__row__td__inner"
																				key={i + 'inner'}
																			>
																				{typeof num === 'number' &&
																					(num == 1 ? (
																						<Check width="32px" height="32px" />
																					) : (
																						<Close width="32px" height="32px" />
																					))}
																				{typeof num === 'string' && t(num)}
																				{num instanceof Array &&
																					num.map((x, i) => (
																						<div
																							key={i + 'desc'}
																							className="shop-present__features-comparison__table__row__td__inner__desc"
																						>
																							{t(x)}
																						</div>
																					))}
																			</div>
																		</td>
																	))}
																</tr>
															</React.Fragment>
														);
													})}
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						)}
						{/* FEATURES COMPARISON */}
						{/* FAQ */}
						<div className="shop-present__faq" ref={faqRef}>
							<div className="container">
								<div className="row">
									<div className="col-12 col-xlg-5">
										<h2 className="shop-present__faq__title">{t('CreateShopPresentation_FAQ_Title')}</h2>
									</div>
									<div className="col-12 col-xlg-7">
										{new Array(6).fill(0).map((_, i) => (
											<div className="shop-present__faq__qa" key={`faq-${i}`}>
												<div className="shop-present__faq__qa__header" onClick={() => toggleFaqDropdown(i)}>
													<h3
														className={classNames('shop-present__faq__qa__header__q', {
															'shop-present__faq__qa__header__q--closed': !faqDropdowns?.[i],
														})}
													>
														{t(`CreateShopPresentation_FAQ_Title_Question_${i}_Title`)}
													</h3>
													{renderIcon(
														'arrow_left',
														undefined,
														undefined,
														classNames('shop-present__faq__qa__header__icon', {
															'shop-present__faq__qa__header__icon--closed': !faqDropdowns?.[i],
														}),
													)}
												</div>
												<p
													className={classNames('shop-present__faq__qa__a', {
														'shop-present__faq__qa__a--closed': !faqDropdowns?.[i],
													})}
												>
													{t(`CreateShopPresentation_FAQ_Title_Question_${i}_Description`)}
												</p>
											</div>
										))}
									</div>
								</div>
							</div>
						</div>
						{/* FAQ */}
						{/* BANNER */}
						<div className="shop-present__banner">
							<div className="container">
								<div className="shop-present__banner__outer" style={{ backgroundImage: `url("${banner_image}")` }}>
									<div className="col-12 col-md-7 col-lg-6 col-xlg-5 col-fhd-4 offset-md-1 offset-xl-2">
										<h2 className="shop-present__banner__outer__title">{t('CreateShopPresentation_Banner')}</h2>
										<CreateShopRegister customTextKey="CreateShopPresentation_OpenSalon_Long" />
									</div>
								</div>
							</div>
						</div>
						{/* BANNER */}
						{/* CONTACT */}
						<div className="shop-present__contact" ref={contactRef}>
							<ContactUsForm />
						</div>
						{/* CONTACT */}
					</div>
				</div>
			);
		},
	),
);

const mapStateToProps = (state: IStore) => ({
	languageDomainValues: state.domainValues.languages,
	userLanguage: state.userLanguage,
});

const mapDispatchToProps = (dispatch: Dispatch<IStore>) => ({
	changeLanguage: (language: number, updateUserPreferences: boolean) =>
		dispatch(changeLanguage(language, updateUserPreferences)),
	getPublishedMenuItems: (menuItemType: MenuItemType) => dispatch(getPublishedMenuItems(menuItemType)),
});

const CreateShopPresentation = connect(mapStateToProps, mapDispatchToProps)(withAuthContext(CreateShopPresentationW));

export { CreateShopPresentation };

// SIGUIENTE PASO CAMBIAR EL TEXTO GROW YOU....... A UN DIV DIFERENTE QUE YA ESTOY MEDIO BORRACHO XD
